import React from "react";
import { cn, getAssetsUrl } from "utils";
import { AnalyzePortfolioModalCallable } from "../../CoPilot";
import { PortfolioActionButton } from "./PortfolioActionButton";
import Translations from "@translate/components/Portfolio/AiPortfolioCard/AiPortfolioCard";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const AiPortfolioCard: React.FC<{ className?: string }> = ({
  className,
}) => {
  // const handleOpenChatModal = useOpenChatModal();

  const onClick = async (type: "health_check" | "happend") => {
    if (type === "health_check") {
      await AnalyzePortfolioModalCallable();
    } else {
      await AnalyzePortfolioModalCallable({ type: "SUMMARY_NEWS" });
    }
  };

  return (
    <div className={cn("w-full flex gap-3", className)}>
      <PortfolioActionButton
        data-openreplay-label={I18n.t("Portfolio Health Check")}
        className="flex-1"
        title={I18n.t("Portfolio Health Check")}
        style={{
          "--icon-url": `url(${getAssetsUrl("/assets/images/portfolio/health_check.svg?v=2")})`,
        }}
        onClick={() => onClick("health_check")}
        iconClassName={cn("[background-image:var(--icon-url)]")}
      />
      <PortfolioActionButton
        data-openreplay-label={I18n.t("What happened today?")}
        className="flex-1"
        title={I18n.t("What happened today?")}
        style={{
          "--icon-url": `url(${getAssetsUrl("/assets/images/portfolio/happend.svg?v=2")})`,
        }}
        onClick={() => onClick("happend")}
        iconClassName={cn("[background-image:var(--icon-url)]")}
      />
    </div>
  );
};
